import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_785s5jxz4n: FaireBrandEntity = {
  token: "b_785s5jxz4n",
  type: "brand",
  name: "NARWEY INC",
  avatarUrl:
    "https://cdn.faire.com/fastly/b2673b15e7ab0793be6d08e21a0d301c8deaa5cb4dedef91097ed75759c5f919.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/97867549913bb413c5ceb4ac0427d5becfebd8b376668c306383ce51dc34f69f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b2673b15e7ab0793be6d08e21a0d301c8deaa5cb4dedef91097ed75759c5f919.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/97867549913bb413c5ceb4ac0427d5becfebd8b376668c306383ce51dc34f69f.jpeg",
  location: "CHN",
  minimumOrderDollars: 99,
  rating: 3.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "Narwey Inc. is an American company that mainly develops, produces, and sells travel bags. \"Narwey\" brand was established in 2019. Its main products include women's cosmetic bags, toiletry bags, duffel bags and other bags. After years of continuous promotion, our brand has been recognized by consumers from all over the world, especially the Narwey toiletry bags, which have become the first choice brand for many travel enthusiasts. Based on consumers' preferences, we continue to innovate, select better fabrics, adhere to superior quality, and produce more products suitable for our fans. Now, we can provide consumers with more choices and hope to cooperate with more retailers to make our brand better.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:45.377Z",
    importedBy: "entity-db-cli",
  },
};
